import {Component, OnInit} from '@angular/core';
import {Restaurant} from "../shared/model/restaurant";
import {RestaurantService} from "../shared/services/restaurant/restaurant.service";
import {ActivatedRoute, Params} from "@angular/router";
import {AuthService} from "../shared/security/auth.service";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  restaurant:Restaurant;
  currentRestaurantName: string;


  constructor(
    private restaurantservice: RestaurantService,
    private route: ActivatedRoute,
    private authService:AuthService
  ) { }





  ngOnInit(){

    this.authService.setShow(true);





    let isEmpty:boolean

    this.route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
      {
        isEmpty = !data.restaurant
        if (!isEmpty) {
          this.restaurant = data.restaurant;
          this.currentRestaurantName = data.restaurant.restaurant;
          this.restaurantservice.setCurrentRestaurant(this.restaurant);
        }else{
          this.restaurantservice.restaurants.subscribe(
            currentRestaurant => { this.currentRestaurantName = currentRestaurant.restaurant; }
          )
        }

      })

  }





}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts